import { useProductDetails } from '@app/pdp/hooks/useProductDetails';
import { personalizedProductMapper } from '@app/pdp/components/PersonalizedProduct/utils/personalizedProductMapper';

export const usePersonalizedProduct = () => {
    const { selectedProduct } = useProductDetails();

    return personalizedProductMapper(selectedProduct);
};
